





import { Track } from '@/classes/track'
import { TRANSFORMERS } from '@/helpers/transformer'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class TrackDeleteModal extends Vue {
  @Prop()
  disabled: boolean

  @Prop()
  tracks: Track[]

  loading: boolean = false

  async open() {
    const { result } = await this.$buefy.dialog.confirm({
      title: 'Remove tracks?',
      type: 'is-danger',
      message: `Are you sure you want to remove <strong>${this.tracks.length}</strong> track${this.tracks.length === 1 ? '' : 's'}?`
    })

    if (result) {
      await this.$store.dispatch('transformer/execute', {
        tracks: this.tracks,
        transformer: TRANSFORMERS.TrackDelete
      })

      this.$buefy.notification.open(`Deleted ${this.tracks.length} track${this.tracks.length === 1 ? '' : 's'}`)
    }
  }
}
